/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { PlayChip } from 'app/components/styled/currencyIcons';

type Props = {
  className?: string,
  currencyCode: string,
  currencySymbol: string
};

function CurrencyIcon({ currencyCode, currencySymbol, className }: Props) {
  if (currencyCode === 'PLA') {
    return <PlayChip className={className} />;
  }

  return <span className={className}>{currencySymbol}</span>;
}

CurrencyIcon.defaultProps = {
  className: undefined
};

function mapStateToProps({ settings }) {
  return {
    currencyCode: settings.currency.code,
    currencySymbol: settings.currency.symbol
  };
}

export default connect(
  mapStateToProps,
  null
)(CurrencyIcon);
